<div class="w-full py-4 flex flex-column align-items-center relative"
  style="background-color: var(--bg-color); border-bottom: 1px solid var(--border-color); margin-top: -32px;">
  <h1 class="w-full text-center font-bold text-2xl m-0" style="color: var(--textdark-color);">Scholarship Finder - <span
      style="color: var(--blue-color);">Deadline Calendar</span></h1>

  <!-- View Toggle Bar -->
  <div class="mt-4 flex bg-white border-round overflow-hidden shadow-1" style="border: 1px solid var(--border-color);">
    <button class="p-link px-4 py-2 font-medium text-sm transition-colors" style="color: var(--text-color);"
      (click)="goToCards()">
      <i class="pi pi-id-card mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
        style="vertical-align: middle;">Cards</span>
    </button>
    <button class="p-link px-4 py-2 font-medium text-sm border-left-1 border-right-1 transition-colors"
      style="background-color: var(--blue-color); color: white;">
      <i class="pi pi-calendar mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
        style="vertical-align: middle;">Calendar</span>
    </button>
    <button class="p-link px-4 py-2 font-medium text-sm border-right-1 transition-colors"
      style="border-color: var(--border-color) !important; color: var(--text-color);" (click)="goToMap()">
      <i class="pi pi-map-marker mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
        style="vertical-align: middle;">Map</span>
    </button>
    <button class="p-link px-4 py-2 font-medium text-sm transition-colors" style="color: var(--text-color);"
      (click)="goToMyScholarships()">
      <i class="pi pi-bookmark mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
        style="vertical-align: middle;">My Scholarships</span>
    </button>
  </div>
</div>

<div class="container_width mt-4">


  <div *ngIf="isLoading" class="w-full flex justify-content-center py-5">
    <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="8" fill="var(--surface-ground)"
      animationDuration=".5s"></p-progressSpinner>
  </div>

  <!-- Timeline Section -->
  <div class="w-full bg-white border-round-lg shadow-1 p-5 mb-5 relative"
    style="border: 1px solid var(--border-color); min-height: 200px;">
    <div class="flex align-items-center justify-content-between relative" style="margin-top: 80px;">
      <!-- Horizontal Line -->
      <div class="absolute w-full"
        style="height: 4px; background-color: #e2e8f0; top: 50%; transform: translateY(-50%); z-index: 1;"></div>

      <!-- Timeline Points -->
      <div *ngFor="let point of timelinePoints" class="relative z-2 flex flex-column align-items-center">
        <!-- Bubble -->
        <div class="absolute cursor-pointer" style="bottom: 40px; transform: translateX(0);"
          (click)="onBubbleClick(point.month)">
          <div class="bubble flex flex-column align-items-center justify-content-center text-white border-circle"
            [ngStyle]="{'background-color': point.color, 'width': '50px', 'height': '50px'}">
            <span class="text-lg font-bold">{{point.count}}</span>
            <!-- <span class="text-xs" style="margin-top: -4px;">Deadlines</span> -->
          </div>
          <!-- Bubble Arrow -->
          <div class="bubble-arrow" [ngStyle]="{'border-top-color': point.color}"></div>
        </div>

        <!-- Dot on line -->
        <div class="border-circle"
          [ngStyle]="{'background-color': point.color, 'width': '12px', 'height': '12px', 'border': '2px solid white', 'box-shadow': '0 0 0 1px #cbd5e1'}">
        </div>

        <!-- Month Label below -->
        <span class="text-xs font-bold text-gray-400 mt-2">{{point.month}}</span>
      </div>
    </div>
  </div>

  <!-- Two Column Layout -->
  <div class="grid" *ngIf="!isLoading">
    <!-- Next 30 Days -->
    <div class="col-12">
      <div class="w-full bg-white border-round-lg shadow-1 overflow-hidden" style="border: 1px solid var(--border-color);">
        <div class="p-4 flex align-items-center gap-2"
          style="background-color: #fdf2f2; border-bottom: 1px solid #fee2e2;">
          <i class="pi pi-calendar text-red-400 font-bold"></i>
          <b class="text-sm font-bold uppercase tracking-wider" style="color: #991b1b;">NEXT 30 DAYS</b>
        </div>

        <div class="flex flex-column">
          <div *ngIf="next30Days.length === 0" class="p-4 text-center text-gray-500 font-medium text-sm">
            No deadlines found in the next 30 days.
          </div>
          <div *ngFor="let item of next30Days" class="p-4 flex align-items-center gap-3 border-bottom-1 cursor-pointer hover:bg-gray-50 transition-colors"
            style="border-color: #f1f5f9;" (click)="openScholarshipDetails(item.scholarship)">
            <div class="date-badge text-white text-xs font-bold px-2 py-1 border-round"
              [style.background-color]="item.color">
              {{item.date}}
            </div>
            <i class="pi pi-briefcase" style="color: #64748b;"></i>
            <span class="text-sm font-bold text-gray-700 flex-1">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Scholarship Details Dialog -->
<p-dialog [(visible)]="scholarshipDialogVisible" [modal]="true" [showHeader]="false"
  styleClass="scholarship-details-dialog-panel"
  [style]="{width: '850px', 'max-width': '95vw', 'max-height': '90vh', 'border-radius': '24px', 'overflow': 'hidden', 'padding': '0'}"
  [contentStyle]="{'padding': '0'}" (onHide)="closeScholarshipDialog()">

  <div class="w-full flex flex-column" *ngIf="selectedScholarship" style="background-color: white; max-height: 90vh;">
    <!-- Header Section -->
    <div class="dialog-header">
      <!-- Close Button -->
      <button class="dialog-close-btn" (click)="closeScholarshipDialog()">
        <i class="pi pi-times"></i>
      </button>

      <!-- Icon & Title -->
      <div class="dialog-title-container">
        <div class="dialog-icon-box">
          <i class="pi pi-graduation-cap"></i>
        </div>
        <h2 class="dialog-title">
          {{selectedScholarship.name}}
        </h2>
      </div>

      <!-- Pills Row -->
      <div class="dialog-pills-row">
        <!-- Pill 1: Country -->
        <div class="dialog-pill">
          <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-pill-flag" />
          <i *ngIf="!getCountryFlag(selectedScholarship.country)" class="pi pi-globe"></i>
          <span>{{getCountryPillName(selectedScholarship.country)}}</span>
        </div>
        <!-- Pill 2: Organization -->
        <div class="dialog-pill">
          <i class="pi pi-home"></i>
          <span>{{selectedScholarship.universityOrOrganisationName || 'Varies'}}</span>
        </div>
        <!-- Pill 3: Deadline -->
        <div class="dialog-pill">
          <i class="pi pi-clock"></i>
          <span>Closes {{getDeadlineDisplay(selectedScholarship.deadLine)}}</span>
        </div>
      </div>
    </div>

    <!-- Scrollable Content Area -->
    <div class="w-full overflow-y-auto overflow-x-hidden" style="flex: 1; background-color: #ffffff;">
      <div class="dialog-body-container">
        <div class="dialog-grid">
          <!-- Left Column: Overview & Eligibility -->
          <div class="dialog-left-col">
            
            <!-- OVERVIEW Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Overview</span>
              
              <div class="dialog-list">
                <!-- Row 1: Country -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-map-marker"></i>
                    </div>
                    <span>Country</span>
                  </div>
                  <div class="dialog-row-value">
                    <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-row-flag" />
                    <span>{{selectedScholarship.country ? getCountryDisplayName(selectedScholarship.country) : 'Global'}}</span>
                  </div>
                </div>

                <!-- Row 2: Organization -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-home"></i>
                    </div>
                    <span>Organization</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="selectedScholarship.universityOrOrganisationName || 'Varies'">
                    {{selectedScholarship.universityOrOrganisationName || 'Varies'}}
                  </div>
                </div>

                <!-- Row 3: Stream -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-book"></i>
                    </div>
                    <span>Stream</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="getStreamDisplayName(selectedScholarship.stream)">
                    {{getStreamDisplayName(selectedScholarship.stream)}}
                  </div>
                </div>

                <!-- Row 4: Level -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-graduation-cap"></i>
                    </div>
                    <span>Level</span>
                  </div>
                  <div class="dialog-row-value">
                    {{getLevelDisplayName(selectedScholarship.level)}}
                  </div>
                </div>
              </div>
            </div>

            <!-- ELIGIBILITY Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Eligibility</span>
              
              <div class="dialog-list">
                <!-- Row 1: Nationality -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-flag"></i>
                    </div>
                    <span>Nationality</span>
                  </div>
                  <div class="dialog-row-value">
                    {{selectedScholarship.eligibility?.nationality || 'Check Eligibility'}}
                  </div>
                </div>

                <!-- Row 2: Academic Requirements -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-file"></i>
                    </div>
                    <span>Academic</span>
                  </div>
                  <div class="dialog-row-value-double">
                    <span class="dialog-val-main">{{getAcademicMainText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                    <span class="dialog-val-sub" *ngIf="getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)">{{getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                  </div>
                </div>

                <!-- Row 3: Others -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-info-circle"></i>
                    </div>
                    <span>Other</span>
                  </div>
                  <div class="dialog-row-value" [class.no-criteria]="!selectedScholarship.eligibility?.others">
                    {{selectedScholarship.eligibility?.others || 'No additional criteria'}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column: What's Covered (Lime Gradient Box) -->
          <div class="dialog-right-col">
            <span class="dialog-section-title">What's Covered</span>
            
            <div class="gradient-card">
              <!-- Funding Amount row -->
              <div class="card-funding-header">
                <div class="funding-icon-box">
                  <i class="pi pi-search"></i>
                </div>
                <div class="funding-text-box">
                  <span class="funding-label">Funding</span>
                  <span class="funding-value">{{getFormattedAmount(selectedScholarship)}}</span>
                </div>
              </div>

              <!-- Coverage checklist items -->
              <div class="card-checklist">
                <div class="checklist-item" [class.not-covered]="!isCovered('tuition')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Tuition covered</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('living')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Living expenses</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('travel')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Travel cost</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('health')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Health insurance</span>
                </div>
              </div>

              <!-- Dotted Divider -->
              <div class="card-divider"></div>

              <!-- Coverage type row -->
              <div class="card-coverage-footer">
                <span class="coverage-label">Coverage type</span>
                <div class="coverage-pill">
                  {{ getCoverageType() }}
                </div>
              </div>
            </div>
            
            <!-- Illustration below the card -->
            <div class="dialog-illustration-box" style="display: flex; justify-content: center; margin-top: 16px; padding-top: 8px;">
              <img src="assets/images/Group 43057.png" alt="What's Covered Illustration" style="max-width: 100%; height: auto; max-height: 180px; display: block;" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer buttons section -->
    <div class="dialog-footer">
      <!-- Left side: Deadline and link -->
      <div class="dialog-footer-left">
        <!-- Deadline badge -->
        <div class="dialog-deadline-badge">
          <div class="deadline-icon-box">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div class="deadline-text-box">
            <span class="deadline-label">Deadline</span>
            <span class="deadline-value">
              {{getDeadlineDisplay(selectedScholarship.deadLine)}}
            </span>
          </div>
        </div>

        <!-- Application Link -->
        <a [href]="selectedScholarship.applicationLink" target="_blank"
           class="dialog-app-link"
           *ngIf="selectedScholarship.applicationLink">
          Application Link <i class="pi pi-arrow-up-right"></i>
        </a>
      </div>

      <!-- Right side: Save and Share buttons -->
      <div class="dialog-footer-right">
        <!-- Save bookmark button (heart style) -->
        <button (click)="toggleMyScholarship(selectedScholarship.id)" class="dialog-bookmark-btn" [style.color]="selectedScholarship.isMyScholarship ? '#ef4444' : '#94a3b8'">
          <i class="pi" [ngClass]="selectedScholarship.isMyScholarship ? 'pi-heart-fill' : 'pi-heart'"></i>
        </button>

        <!-- Share with mentor button -->
        <button (click)="shareMenu.toggle($event)" class="dialog-share-btn">
          Share with mentor
        </button>
      </div>

      <!-- Mentor Share overlay panel inside the footer -->
      <p-overlayPanel #shareMenu [showCloseIcon]="false">
        <div class="flex flex-column gap-2 p-1" style="min-width: 200px;">
          <b class="text-xs font-bold text-gray-500 mb-2 uppercase tracking-wider">Share with</b>

          <ng-container *ngIf="studentMentors.length > 0; else noMentorMenuTemplate">
            <div *ngFor="let mentor of studentMentors"
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-blue-50 transition-colors"
              (click)="selectedMentorToShare = mentor; shareScholarshipWithMentor(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">{{mentor.label}}</span>
                <span class="text-xs text-gray-500">Your Mentor</span>
              </div>
            </div>
          </ng-container>

          <ng-template #noMentorMenuTemplate>
            <div
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-orange-50 transition-colors"
              (click)="navigateToMentors(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">No Mentor Found</span>
                <span class="text-xs text-blue-600 font-medium">Choose your mentor</span>
              </div>
            </div>
          </ng-template>
        </div>
      </p-overlayPanel>
    </div>
  </div>
</p-dialog>